<template>
  <div class="before-connect">请选择您遇到的问题类型</div>
</template>

<script>
//询前页头部
export default {
  name: "before-page-header"
};
</script>

<style scoped lang="less">
.before-connect {
  font-family: PingFang TC;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: var(--pre-header-text-color);
}
</style>
